import {
  normalizarRegistroDesdeSheet,
  serializarRegistroParaSheet
} from "../utils/registroSchema";

const API_URL = "https://script.google.com/macros/s/AKfycbzmPN49_jJr1jLaBkmzQ-Lo5Duos9TOCsXE5rexGz9Rr1k6mAZOEjaTtPUN0ufCFjd27Q/exec";

export const getData = async () => {
  const res = await fetch(API_URL);
  const json = await res.json();
  const data = Array.isArray(json) ? json : json?.data;

  if (!Array.isArray(data)) {
    throw new Error("El Apps Script no devolvio una lista valida de registros.");
  }

  return data.map((item) => normalizarRegistroDesdeSheet(item));
};

const enviarDatos = async (data) => {
  const res = await fetch(API_URL, {
    method: "POST",
    headers: {
      "Content-Type": "text/plain;charset=utf-8"
    },
    redirect: "follow",
    body: JSON.stringify(serializarRegistroParaSheet(data))
  });

  const responseText = await res.text();

  if (!res.ok) {
    throw new Error(`El Apps Script respondio con estado ${res.status}.`);
  }

  if (responseText.trim().startsWith("<!DOCTYPE html") || responseText.trim().startsWith("<html")) {
    throw new Error("La URL del Apps Script no esta respondiendo como API. Revisa el despliegue web.");
  }

  if (!responseText) {
    return { message: "Datos guardados" };
  }

  try {
    return JSON.parse(responseText);
  } catch {
    throw new Error("El Apps Script devolvio una respuesta no valida.");
  }
};

export const postData = async (data) => enviarDatos(data);

export const updateData = async (data) =>
  enviarDatos({
    ...data,
    action: "update"
  });

export const deleteData = async (data) =>
  enviarDatos({
    ...data,
    action: "delete"
  });
